/**
 * 获取当前时间对应的中文问候语
 * @returns {string} 问候语和帮助提示
 */
export const getChineseGreeting = (): string => {
  const now = new Date();
  const hour = now.getHours();
  const minute = now.getMinutes();
  const currentMinutes = hour * 60 + minute;

  // 转换时间为分钟，便于比较
  const time = {
    earlyMorning: 4 * 60, // 4:00
    morning: 9 * 60, // 9:00
    noon: 12 * 60, // 12:00
    afternoon: 13 * 60 + 30, // 13:30
    evening: 18 * 60, // 18:00
    lateNight: 24 * 60, // 24:00
  };

  let greeting = '';

  if (currentMinutes >= time.earlyMorning && currentMinutes < time.morning) {
    greeting = '早上好';
  } else if (currentMinutes >= time.morning && currentMinutes < time.noon) {
    greeting = '上午好';
  } else if (currentMinutes >= time.noon && currentMinutes < time.afternoon) {
    greeting = '中午好';
  } else if (currentMinutes >= time.afternoon && currentMinutes < time.evening) {
    greeting = '下午好';
  } else if (currentMinutes >= time.evening || currentMinutes < time.earlyMorning) {
    greeting = '晚上好';
  }

  return `${greeting}，有什么可以帮忙的？`;
};

/**
 * Get current time-based English greeting
 * @returns {string} Greeting and help message
 */
export const getEnglishGreeting = (): string => {
  const now = new Date();
  const hour = now.getHours();
  const minute = now.getMinutes();
  const currentMinutes = hour * 60 + minute;

  const time = {
    morning: 4 * 60, // 4:00
    afternoon: 12 * 60, // 12:00
    evening: 18 * 60, // 18:00
    lateNight: 24 * 60, // 24:00
  };

  let greeting = '';

  if (currentMinutes >= time.morning && currentMinutes < time.afternoon) {
    greeting = 'Good morning';
  } else if (currentMinutes >= time.afternoon && currentMinutes < time.evening) {
    greeting = 'Good afternoon';
  } else if (currentMinutes >= time.evening || currentMinutes < time.morning) {
    greeting = 'Good evening';
  }

  return `${greeting}, how can I help you today?`;
};
